/** These targets changed from Nudge Lite to a 70:30 split on this date. */
export const NUDGE_SPLIT_DATE = '2026-09-01';
const SPLIT_TARGETS = new Set([
  'volvocars',
  'volvocars_ch_fr',
  'volvocars_ch_it',
  'transa',
]);
// Components read the mode from templates as well as API branches.
let lastStartDate: string | undefined;
let lastHistoricalLite = false;

export function hasNudgeSplit(target: string | null | undefined): boolean {
  return SPLIT_TARGETS.has(target || '');
}

export function nudgeSplitDate(): Date {
  return new Date(2026, 8, 1);
}

export function nudgeLiteEndDate(): Date {
  return new Date(2026, 7, 31, 23, 59, 59, 999);
}

/** Stored dates are UTC instants with an @IANA-timezone suffix. */
export function resolveNudgeLite(
  target: string | null | undefined,
  startDate: string | null | undefined,
  configuredLite: boolean,
): boolean {
  if (!hasNudgeSplit(target) || !startDate) return configuredLite;
  if (startDate === lastStartDate) return lastHistoricalLite;

  const [iso, timeZone] = startDate.split('@');
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return configuredLite;

  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone || 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(date);
    const part = (type: string) => parts.find((p) => p.type === type)?.value;
    const historicalLite = `${part('year')}-${part('month')}-${part('day')}` < NUDGE_SPLIT_DATE;
    lastStartDate = startDate;
    lastHistoricalLite = historicalLite;
    return historicalLite;
  } catch {
    return configuredLite;
  }
}

/** Preserve the selected start day; never include both group splits. */
export function constrainNudgeRange(startDate: Date, endDate: Date): Date {
  if (startDate < nudgeSplitDate() && endDate >= nudgeSplitDate()) {
    return nudgeLiteEndDate();
  }
  return endDate;
}
